import React from 'react';
import '../styles.css';
import AppBar from '../components/AppBar.js';
import LevelSelectDescription from '../components/levelSelect/LevelSelectDescription.js';
import LevelSelectGrid from '../components/levelSelect/LevelSelectGrid';
import { Link } from 'react-router-dom'

function LevelSelect() {
    return (
        <div>
            <AppBar name='Level Select' displayText='Home' backTo='' />
            <div className='column' style={{ marginTop: 100 }}>
                <LevelSelectDescription text='Reading' />
                <Link to='/HowTo' className='mainMenuOption' style={{ marginBottom: 50 }}>How To Play</Link>
                <LevelSelectGrid />
            </div>
        </div>
    );
}

export default LevelSelect;